import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { ContactSidePanelDetails } from "./ContactSidePanelDetails";


interface ContactSidePanelProps {
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
  contactId: number
}

export const ContactSidePanel = (props: ContactSidePanelProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Contact.Preview(props.contactId)}
    apiKey="contact"
    entityId={props.contactId}
    title={RESX.Contact.resxContact}
    footerContent={
      <ButtonPrimary href={routes.contact_Detail(props.contactId).absolute} label={RESX.Buttons.DetailView} />
    }
    trigger={props.trigger}
  >
    {(contact, refetch) => <ContactSidePanelDetails
      contact={contact}
      refetch={refetch}
    />}
  </DetailSidePanel>;
};